// extracted by mini-css-extract-plugin
module.exports = {"BackBar":"Ticketing_BackBar__4LmNa","SubmitBox":"Ticketing_SubmitBox__3uN6r"};